import styled from "styled-components";
import Image from "../Image";
import { colors, media } from "../../style/constants";

export const Wrapper = styled.section`
  display: grid;
  grid-template-columns: repeat(8, 1fr);
  grid-template-rows: repeat(5, 1fr);
  position: relative;
  height: 100vh;
  height: 100lvh;
  grid-gap: 1rem;
  padding: 1rem;
  ${media.md`
  padding: 3rem;
  `}
  ${media.sm`
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(5, 1fr);
    padding: 1.5rem;
  `}
`;

export const StyledImage = styled(Image)`
  grid-area: 1 / 3 / 5 / 9;
  position: relative;
  overflow: hidden;
  margin: -1rem;

  img {
    position: absolute;
    width: 100%;
    height: 100%;
    margin: auto;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;
    display: block;
    object-fit: contain;
    object-position: center;
    z-index: 2;
    ${media.sm`

    `}
  }

  ${media.md`
  margin: -3rem;
  `}
  ${media.sm`
  margin: -1.5rem;
    grid-area: 1 / 5 / 4 / 1;
    &:before {
      padding-top: 100%;
    }
  `}
`;

export const InfoWrapper = styled.header`
  grid-row: 5 / 5;
  grid-column: 2 / 6;
  z-index: 3;
  align-self: center;
  ${media.md`
  grid-row: 5 / 6;
    grid-column: 1 / 5;
    align-self: center;
  `}
  ${media.sm`
  align-self: start;

    /* padding: 0 2rem; */
  `}
  .sub {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    font-size: 0.88rem;
    line-height: 1.25;
    gap: 2rem;
    margin-top: 1rem;
    p {
      margin: 0;
      width: 45%;
    }
  }
`;

export const Content = styled.main`
  margin-top: 1rem;
  line-height: 1.8em;
  color: ${colors.gray500};
  .windermere {
    text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.4);
    color: #fff;
    a {
      border-bottom-color: #fff;
      &:hover {
        border-bottom: 1px solid #fff;
      }
    }
  }
  ${media.sm`
    margin-top: 1rem;
  `}

  h1 {
    font-weight: 400;
  }

  p {
    margin: 1.5rem 0;
  }

  a {
    color: #fff;
    border-bottom: 1px dotted ${colors.gray500};

    &:hover {
      border-bottom-color: ${colors.red500};
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/TheBurningGlassHeaderSection/style.js